module.exports = __webpack_public_path__ + "assets/img/qualification_certificate2.03b9dab9.jpg";